import React from 'react';
import {SpinnerOverlayProvider} from './src/components/spinner-overlay';

import "./src/styles/global.scss";

export const wrapRootElement = ({ element }) => {
  return <SpinnerOverlayProvider>{element}</SpinnerOverlayProvider>;
};
